import React, { useRef } from "react";
import { Button, Form } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "./contact.scss";
import emailjs from "@emailjs/browser";
import MyVerticallyCenteredModal from "./../../Modal/Modal";

const Email = () => {
  const form = useRef();
  const [modalShow, setModalShow] = React.useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_z1u4a9f",
        "template_x96e4fl",
        form.current,
        "K3h8GWKpiQHFZZse7"
      )
      .then(
        (result) => {
          setModalShow(true);
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <>
      <section id="contact" className="contact py-5">
        <Container className="py-md-5">
          <div className="text-center mb-sm-5 mb-5">
            <h5 className="title text-uppercase">For Emergency Contact</h5>
            <h3 className="fs-1 fw-bold ">
              For Emergency Contact, you can submit this form
            </h3>
          </div>
          <Row className="form-width mx-auto py-5">
            <Form ref={form} onSubmit={sendEmail}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  required
                  className="border border-danger"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email address"
                  name="email"
                  required
                  className="border border-danger"
                />
                <Form.Text className="text-muted">
                  We'll never share your email with anyone else.
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Subject</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Subject"
                  name="subject"
                  required
                  className="border border-danger"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Your Message</Form.Label>
                <Form.Control
                  as="textarea"
                  style={{ height: "100px" }}
                  placeholder="Your Message"
                  name="message"
                  required
                  className="border border-danger"
                />
              </Form.Group>

              <Button className="card__btn w-50 mx-auto d-block" type="submit">
                Submit
              </Button>
            </Form>
          </Row>
        </Container>
        {/* <ToastContainer /> */}
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </section>
    </>
  );
};

export default Email;
